// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"612":"security-policy","981":"documents"}[chunkId] + "." + {"612":"eed11397","981":"bac9013b"}[chunkId] + ".css";
};